/**
 * SectionPage — the shared section frame: page title = rail label verbatim
 * (Krug page-name contract; one source string from copyTokens), an optional
 * one-line blurb (Business landing only), then the wrapped content.
 * Sections WRAP existing pages unedited (wrap now, port later).
 */

import type { ReactNode } from 'react';
import { COPY, type SettingsSectionId } from '@/lib/copyTokens';

export function SectionPage({
  sectionId,
  blurb,
  children,
}: {
  sectionId: SettingsSectionId;
  blurb?: string;
  children: ReactNode;
}) {
  const { label } = COPY.sections[sectionId];
  return (
    <section aria-label={label} className="w-full min-w-0">
      <header className="mb-4">
        <h2 className="text-xl font-medium leading-8 text-ink">{label}</h2>
        {blurb ? <p className="mt-1 text-sm leading-6 text-ink-2">{blurb}</p> : null}
      </header>
      {children}
    </section>
  );
}
